export default __webpack_public_path__ + "static/media/customer_io_logo.46d298ac.webp";